import React from "react";

// Helper function to get formatted service names from appointment
const getServiceNames = (appointment) => {
  // Handle new format: service_names array
  if (appointment.service_names && Array.isArray(appointment.service_names)) {
    return appointment.service_names.join(', ');
  }
  // Handle old format: single service_name string
  if (appointment.service_name) {
    return appointment.service_name;
  }
  // Fallback to service field
  if (appointment.service) {
    return appointment.service;
  }
  return 'N/A';
};

export default function AppointmentDetailsModal({
  isOpen,
  appointment,
  onClose,
  formatDateTime,
  getServiceWorkerName,
  getPatientName,
  getStatusBadgeClass,
  showCaregiver,
  onEditAppointment,
  onDeleteAppointment,
}) {
  if (!isOpen || !appointment) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content appointment-details-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2>Appointment Details</h2>
          <button
            className="modal-close"
            onClick={onClose}
            aria-label="Close modal"
          >
            ×
          </button>
        </div>
        <div className="appointment-details-content">
          <div className="detail-row">
            <span className="detail-label">Date:</span>
            <span className="detail-value">
              {formatDateTime(appointment.start_date).date}
            </span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Start Time:</span>
            <span className="detail-value">
              {formatDateTime(appointment.start_date).time}
            </span>
          </div>
          {appointment.end_date && (
            <div className="detail-row">
              <span className="detail-label">End Time:</span>
              <span className="detail-value">
                {formatDateTime(appointment.end_date).time}
              </span>
            </div>
          )}
          {getServiceWorkerName && !showCaregiver && (
            <div className="detail-row">
              <span className="detail-label">Service Worker:</span>
              <span className="detail-value">
                {getServiceWorkerName(appointment.psw_id)}
              </span>
            </div>
          )}
          {showCaregiver && (
            <div className="detail-row">
              <span className="detail-label">Caregiver:</span>
              <span className="detail-value caregiver-id">{appointment.psw_name || "N/A"}</span>
            </div>
          )}
          {getPatientName && (
            <div className="detail-row">
              <span className="detail-label">Patient:</span>
              <span className="detail-value">
                { appointment.user_name || 'N/A' }
              </span>
            </div>
          )}
          <div className="detail-row">
            <span className="detail-label">Service:</span>
            <span className="detail-value">{getServiceNames(appointment)}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Status:</span>
            <span
              className={`status-badge ${getStatusBadgeClass(
                appointment.status
              )}`}
            >
              {appointment.status || "N/A"}
            </span>
          </div>
          {appointment.location && (
            <div className="detail-row">
              <span className="detail-label">Location:</span>
              <span className="detail-value">{appointment.location}</span>
            </div>
          )}
          {appointment.description && (
            <div className="detail-row">
              <span className="detail-label">Description:</span>
              <span className="detail-value">{appointment.description}</span>
            </div>
          )}
        </div>
        <div className="modal-actions">
          <button
            type="button"
            className="modal-button-cancel"
            onClick={onClose}
          >
            Close
          </button>
          {onEditAppointment && (
            <button
              type="button"
              className="modal-button-submit"
              onClick={() => {
                onClose();
                onEditAppointment(appointment);
              }}
            >
              Edit Appointment
            </button>
          )}
          {onDeleteAppointment && (
            <button
              type="button"
              className="modal-button-cancel"
              onClick={() => {
                onDeleteAppointment(appointment);
              }}
              style={{
                backgroundColor: '#dc2626',
                borderColor: '#dc2626',
                color: 'white'
              }}
            >
              Delete Appointment
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
